import { Alert } from "@mui/material";

interface FormSuccessProps {
    message?: string;
};

export const FormSuccess = ({
    message,
}: FormSuccessProps) => {
    if (!message) return null;

    return (
        <Alert severity="success">
            {message}
        </Alert>
    );
};
